<div class="page page--vcenter" [ngClass]="{'show-passcode': showPasscode}">
  <div class="home__brand" [ngClass]="{'brand--passcode': showPasscode}" (click)="showPasscode = true">
    <img class="brand__logo" src="../../assets/images/CaptoMD-logo.svg" alt="CaptoMD">
  </div>

  <capto-passcode class="home__passcode" *ngIf="showPasscode || !showPasscode"></capto-passcode>
</div>
